import { render } from "./ApiReference.vue?vue&type=template&id=61c1fa4c&scoped=true"
import script from "./ApiReference.vue?vue&type=script&lang=js"
export * from "./ApiReference.vue?vue&type=script&lang=js"

import "./ApiReference.vue?vue&type=style&index=0&id=61c1fa4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c1fa4c"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QIcon,QBtn,QSpinner});
